import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ReactComponent as NewMessageIcon } from "../../../common/icons/new-message.svg";
import ConversationSearchField from "../ConversationSearchField";
import { BORDER } from "../constants";
import MessagingToolbar from "../MessagingToolbar";
import useInboxConversationList from "../useInboxConversationList";
import { Conversation } from "../types/queries";
import InboxConversationList from "./InboxConversationList";
import MessagingInboxListContainer from "./MessagingInboxListContainer";
import MessagingInboxTabs from "./MessagingInboxTabs";

type Props = {
  onConversationChange: (conversation: Conversation) => void;
  tabIndex: number;
  handleTabChange: (newValue: number) => void;
  initializeNewConversation: () => void;
  loadMore: () => void;
};

const MessagingInbox = ({
  tabIndex,
  handleTabChange,
  initializeNewConversation,
  onConversationChange,
  loadMore,
}: Props) => {
  const { t } = useTranslation("messaging");
  const { conversations, loading, loadingMore, emptyLabel, searching } =
    useInboxConversationList();

  const toolbarActions = [
    {
      onClick: initializeNewConversation,
      icon: <NewMessageIcon />,
      ariaLabel: t("newMessage"),
    },
  ];

  return (
    <Grid
      item
      container
      sx={{
        borderRight: BORDER,
        height: "100%",
        flex: "0 0 400px",
        width: 400,
        maxWidth: 400,
        minWidth: 400,
      }}
    >
      <MessagingInboxTabs
        value={searching ? false : tabIndex}
        handleTabChange={handleTabChange}
      />
      <MessagingToolbar
        inputComponent={<ConversationSearchField />}
        actions={toolbarActions}
        GridProps={{ item: true, xs: 12 }}
      />
      <MessagingInboxListContainer>
        <InboxConversationList
          conversations={conversations}
          loading={loading}
          loadingMore={loadingMore}
          loadMore={loadMore}
          emptyLabel={emptyLabel}
          onConversationChange={onConversationChange}
        />
      </MessagingInboxListContainer>
    </Grid>
  );
};

export default MessagingInbox;
